/**
 * Determines whether the `value` is an array literal.
 */
const isArray = value => {
  return Array.isArray(value);
};

export { isArray as i };
